import baseEditForm from "formiojs/components/_classes/component/Component.form";

export default (...extend) => {
  return baseEditForm(
    [
      {
        key: "display",
        components: []
      },
      {
        key: "data",
        components: [
          {
            label: "Override Existing Mapped Component Values",
            key: "overrideExistingValues",
            input: true,
            type: "checkbox",
            weight: 12
          },
          {
            type: "editgrid",
            label: "Component Maps",
            key: "compMaps",
            storeas: "array",
            input: true,
            addAnother: "Add Component Map",
            weight: 12,
            templates: {
              header:
                '<div class="row"> \n  <div class="col-sm-12">\n   <strong>{{ value.length }} Component Map(s) Configured</strong>\n  </div>\n</div>',
              row:
                '<div class="row"> \n  <div class="col-sm-6">\n   <b>\n{{ row.lookupFieldName }}</b>\n  </div>\n  <div class="col-sm-6"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-info editRow">Edit</div> \n      <div class="btn btn-danger removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
              footer: ""
            },
            components: [
              {
                label: "Response Element",
                key: "lookupFieldName",
                input: true,
                type: "textfield"
              },
              {
                label: "API Property Name",
                key: "modelFieldName",
                input: true,
                type: "textfield"
              },
              {
                label: "Form Lookup Type",
                key: "lookupFieldType",
                type: "select",
                input: true,
                dataSrc: "values",
                data: {
                  values: [
                    {
                      key: "Code",
                      label: "Coded Value",
                      value: "code"
                    },
                    {
                      key: "Description",
                      label: "Text",
                      value: "description"
                    }
                  ]
                }
              },
              {
                type: "editgrid",
                label: "Code Translations",
                key: "codeTranslations",
                storeas: "array",
                input: true,
                addAnother: "Add Code Translation",
                templates: {
                  header:
                    '<div class="row"> \n  <div class="col-sm-12">\n    <strong>{{ value.length }} Code Translation(s) Configured</strong>\n  </div>\n</div>',
                  row:
                    '<div class="row"> \n  <div class="col-sm-3 col-md-4">\n   <table style="font-size: small">\n <tr>\n<td>Lookup Code</td> \n</tr>\n <tr>\n <td>{{ row.lookupValue }}</td>\n </tr>\n </table>\n </div>\n <div class="col-sm-3 col-md-4"> \n <table style="font-size: small">\n <tr>\n<td>Alacrity Code</td>\n </tr>\n <tr>\n<td>{{row.outputValue}}</td> \n </tr>\n </table>\n </div>\n  <div class="col-sm-6 col-md-4"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-sm btn-info editRow">Edit</div> \n      <div class="btn btn-sm btn-danger removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
                  footer: ""
                },
                components: [
                  {
                    label: "Response Code",
                    key: "lookupValue",
                    input: true,
                    type: "textfield"
                  },
                  {
                    label: "Alacrity Form Code",
                    key: "outputValue",
                    input: true,
                    type: "textfield"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: "validation",
        components: []
      },
      {
        key: "api",
        components: [
          {
            type: "textfield",
            input: true,
            label: "External API Address",
            key: "externalURL",
            weight: 12
          }
        ]
      },
      {
        key: "conditional",
        components: []
      },
      {
        key: "logic",
        components: []
      }
    ],
    ...extend
  );
};
